import React from 'react';
import {
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  Box,
  IconButton,
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { GetApp } from '@material-ui/icons';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import CustomToolbar from '../global/CustomToolbar';
import { DEFAULT_PDF_ZOOM } from '../global/constants';
import Utils from '../Utils/Utils';
import {
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
} from '../../redux/actions/ticketOut';
import { previewBonusSelector } from '../../redux/selectors/settings';
import {
  globalPDFPreviewReadySelector,
  reportPhotosSelector,
} from '../../redux/selectors/ticketOut';
import withShipment from '../../withShipment';
import RenderPurchaseOrderPDFPreview from '../transaction/RenderPurchaseOrderPDFPreview';
import { statusSelector } from '../../redux/selectors/global';
import { clearStatus } from '../../redux/actions/global';
import ErrorFeedbackBar from '../global/ErrorFeedbackBar';
import FeedbackBar from '../feedbackBar/FeedbackBar';
import { Dialog, DialogContent, DialogTitle, Divider } from '@material-ui/core';
import PrintIcon from '@mui/icons-material/Print';
import EditIcon from '@material-ui/icons/Edit';
import Transaction from '../transaction/Transaction';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import PaymentPopperTransaction from '../transaction/PaymentPopperTransaction';

class ReportList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPdfViewer: false,
      pdfLoadSuccess: true,
      pdfData: [],
      scale: DEFAULT_PDF_ZOOM,
      feedbackBarOpen: false,
      selectedIntent: '',
      isShowPhoto: false,
      reportPhotos: [],
      isEditShiftReport: false,
      isDialogOpen: false,
    };
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar();
    }

    if (prevProps.reportPhotos !== this.props.reportPhotos) {
      this.setState({
        reportPhotos: this.props.reportPhotos,
      });
    }

    if (
      !this.arrayEquals(prevProps.PDFPreviewReady, this.props.PDFPreviewReady)
    ) {
      this.setState({
        pdfData: this.props.PDFPreviewReady,
      });
    }
  }

  setShiftReportView = (bool) => {
    this.setState({ isEditShiftReport: bool });
  };

  //report

  showPdfErrorMessage = (isFailed) => {
    this.props.resetGlobalPdfPreviewData();
    this.setState({ pdfLoadSuccess: !isFailed });
  };

  closePdfViewer = () => {
    this.setState({ showPdfViewer: false, pdfData: '' }); // Close the PDF viewer and reset URL
  };

  download = () => {
    const date = new Date();
    const getTodayDate = Utils.formatTodayDate(date);
    const fileName = `${this.props.employee?.name}-${this.state.selectedIntent}-${getTodayDate}.pdf`;

    Utils.handlePdfAction(this.state.pdfData, 'download', fileName);
  };

  setZoom(zoom) {
    let newScale = Math.min(Math.max(this.state.scale + zoom, 1), 2);
    this.setState({
      scale: newScale,
    });
  }

  arrayEquals(arr1, arr2) {
    if (!arr1 || !arr2) return false;
    if (arr1.length !== arr2.length) return false;
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) return false;
    }
    return true;
  }

  //end report

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {
        this.props.clearStatus();
      }
    );
  };

  handleOpenDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  // Close dialog function
  handleCloseDialog = () => {
    this.setState({ isDialogOpen: false });
  };

  fetchPdf = async (intent) => {
    const { employee } = this.props;
    const date = Utils.formatDateMMDDYYYYTime(employee.clockIn);
    this.setState({ selectedIntent: intent });

    switch (intent) {
      case 'points':
        this.props.getGlobalPDFPreview(
          {
            userId: employee.userId,
            locationId: employee.locationId,
            date: date,
            clockId: employee.clockId,
          },
          this.showPdfErrorMessage,
          'previewPointReport'
        );
        break;

      case 'shift':
        this.props.getGlobalPDFPreview(
          {
            userId: employee.userId,
            locationId: employee.locationId,
            date: date,
            clockId: employee.clockId,
          },
          this.showPdfErrorMessage,
          'previewShiftReport'
        );
        break;

      case 'raffle':
        this.props.getGlobalPDFPreview(
          {
            userId: employee.userId,
            locationId: employee.locationId,
            date: date,
            clockId: employee.clockId,
          },
          this.showPdfErrorMessage,
          'previewRaffleReport'
        );
        break;

      case 'bonus':
        this.props.getGlobalPDFPreview(
          {
            userId: employee.userId,
            locationId: employee.locationId,
            date: date,
            clockId: employee.clockId,
          },
          this.showPdfErrorMessage,
          'previewBonusReport'
        );
        break;

      case 'ticketOut':
        this.props.getGlobalPDFPreview(
          {
            userId: employee.userId,
            locationId: employee.locationId,
            date: date,
            clockId: employee.clockId,
          },
          this.showPdfErrorMessage,
          'previewTicketOutReport'
        );
        break;

      default:
        console.warn('Unknown intent passed to fetchPdf:', intent);
        return;
    }

    this.setState({ showPdfViewer: true });
  };

  render() {
    const { showPdfViewer, pdfData, scale, selectedIntent } = this.state;

    const reports = [
      { name: 'Points Report', intent: 'points' },
      { name: 'Ticket Out Report', intent: 'ticketOut' },
      { name: 'Shift Report', intent: 'shift' },
      { name: 'Raffle Report', intent: 'raffle' },
      { name: 'Bonus Report', intent: 'bonus' },
    ];

    let headerButtons = [];

    // Case: Editing Shift Report
    if (this.state.isEditShiftReport) {
      headerButtons.push(
        {
          title: 'Back',
          icon: <KeyboardBackspaceIcon />,
          handler: () => this.setShiftReportView(false),
        },

        {
          icon: <LocalAtmIcon />,
          title: 'Set Cash Left',
          handler: () => this.handleOpenDialog(),
        }
      );
    }
    // Case: PDF Viewer
    else if (showPdfViewer) {
      if (this.state.isShowPhoto) {
        // When viewing photos in PDF mode, show only back button
        headerButtons = [
          {
            title: 'Back',
            icon: <KeyboardBackspaceIcon />,
            handler: () => this.setState({ isShowPhoto: false }),
          },
        ];
      } else {
        // Normal PDF viewer buttons
        headerButtons.push(
          {
            icon: <KeyboardBackspaceIcon />,
            handler: () => this.closePdfViewer(),
            title: 'Back',
          },
          {
            icon: <GetApp />,
            handler: () => this.download(),
            title: 'Download PDF',
            disabled: !this.state.pdfData || this.state.pdfData.length === 0,
          },
          {
            icon: <PrintIcon />,
            title: 'Print PDF',
            disabled: !this.state.pdfData || this.state.pdfData.length === 0,
            handler: () => {
              if (!this.state.pdfData) return;
              const fileName = `${this.props.employee?.name}-${this.state.selectedIntent}.pdf`;
              Utils.handlePdfAction(this.state.pdfData, 'print', fileName);
            },
          },
          {
            icon: <ZoomOutIcon />,
            handler: () => this.setZoom(-0.25),
            title: 'Zoom Out',
            disabled: !this.state.pdfData || this.state.pdfData.length === 0,
          },
          {
            divider: (
              <span style={{ padding: '5px', marginTop: '5px' }}>
                {this.state.scale * 100}%
              </span>
            ),
          },
          {
            icon: <ZoomInIcon />,
            handler: () => this.setZoom(0.25),
            title: 'Zoom In',
            disabled: !this.state.pdfData || this.state.pdfData.length === 0,
          }
        );

        // Optional: Add Photo Library icon for certain intents
        if (
          (selectedIntent === 'bonus' || selectedIntent === 'raffle') &&
          Array.isArray(this.state.reportPhotos) &&
          this.state.reportPhotos.length > 0
        ) {
          headerButtons.push({
            icon: <PhotoLibraryIcon />,
            handler: () =>
              this.setState({ isShowPhoto: !this.state.isShowPhoto }),
            title: 'View Images',
          });
        }
      }
    }
    // Default / fallback
    else {
      headerButtons.push({
        title: 'Back',
        icon: <KeyboardBackspaceIcon />,
        handler: () => this.props.handleEditingClear(),
      });
    }

    return (
      <>
        <CustomToolbar
          title={
            this.state.isEditShiftReport && this.props.employee?.name
              ? `Shift Report — ${this.props.employee.name}`
              : ''
          }
          createTitle={''}
          backTitle={''}
          headerButtons={headerButtons}
        />

        <ErrorFeedbackBar />
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        <Dialog
          open={this.state.isDialogOpen}
          onClose={this.handleCloseDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Set Cash Left</DialogTitle>
          <DialogContent>
            <PaymentPopperTransaction
              clockId={this.props.employee.clockId}
              modifyUserId={this.props.userInfo.userId}
              userId={this.props.employee.userId} // Passing the userId prop
              openFeedbackBar={this.openFeedbackBar} // Passing the feedback bar handler
              handleClosePopper={this.handleCloseDialog} // Close the dialog when save or close
            />
          </DialogContent>
        </Dialog>

        {showPdfViewer ? (
          this.state.isShowPhoto ? (
            <Box
              sx={{
                padding: 4,
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
              }}
            >
              {selectedIntent === 'raffle' &&
                this.state.reportPhotos?.length > 0 &&
                this.state.reportPhotos.map((photoItem, index) => (
                  <Card
                    key={index}
                    sx={{ borderRadius: 4, boxShadow: 3, p: 3 }}
                  >
                    <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
                      <strong>{photoItem.name}</strong> (${photoItem.amount})
                    </Typography>
                    <Box
                      sx={{
                        display: 'flex',
                        flexWrap: 'wrap',
                        gap: 3,
                        justifyContent: 'center',
                      }}
                    >
                      {[
                        ...(photoItem.photo || []),
                        ...(photoItem.files || []),
                      ].map((img, i) => (
                        <Box
                          key={i}
                          sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            mb: 3,
                          }}
                        >
                          <Typography variant="h5" sx={{ mb: 1 }}>
                            {i === 0 ? 'ID Picture' : 'Validation Picture'}
                          </Typography>
                          <Box
                            component="img"
                            src={img.localURL.replace(/\\/g, '/')}
                            alt={`image-${i}`}
                            sx={{
                              width: { xs: '100%', sm: '350px', md: '550px' },
                              maxHeight: '600px',
                              borderRadius: 2,
                              objectFit: 'cover',
                              boxShadow: 2,
                              transition: 'transform 0.3s ease',
                              cursor: 'pointer',
                              '&:hover': {
                                transform: 'scale(1.05)',
                              },
                            }}
                          />
                        </Box>
                      ))}
                    </Box>
                  </Card>
                ))}

              {selectedIntent === 'bonus' &&
                this.state.reportPhotos?.length > 0 &&
                this.state.reportPhotos.map((bonus, index) => (
                  <Card
                    key={index}
                    sx={{ borderRadius: 4, boxShadow: 3, p: 3, mb: 3 }}
                  >
                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                      Full Name: {bonus.firstName} {bonus.lastName}
                    </Typography>
                    <Typography variant="body1">
                      Bonus: {bonus.bonusName} ({bonus.specify})
                    </Typography>
                    <Typography variant="body1">
                      Amount: ${bonus.bonusAmount}
                    </Typography>
                    <Typography variant="body1">
                      Machine: {bonus.machine}
                    </Typography>
                    <Typography variant="body1">Time: {bonus.time}</Typography>

                    {bonus.imageUrl && (
                      <Box
                        component="img"
                        src={bonus.imageUrl}
                        alt="bonus-image"
                        sx={{
                          width: { xs: '100%', sm: '350px', md: '550px' },
                          maxHeight: '600px',
                          borderRadius: 2,
                          objectFit: 'cover',
                          boxShadow: 2,
                          mt: 2,
                        }}
                      />
                    )}
                  </Card>
                ))}
            </Box>
          ) : (
            <RenderPurchaseOrderPDFPreview
              data={pdfData}
              handleSubmit={this.handleSubmit}
              creating={true}
              handlePdfLoadSuccess={this.props.handlePdfLoadSuccess}
              handlePdfLoadError={this.props.handlePdfLoadError}
              scale={scale}
            />
          )
        ) : this.state.isEditShiftReport ? (
          <Transaction
            userId={this.props.employee.userId}
            locationId={this.props.employee.locationId}
            clockId={this.props.employee.clockId}
            isToolbar={false}
            fromEmployeeSession={true}
          />
        ) : (
          <Box sx={{ maxWidth: 'auto', mx: 'auto', mt: 6, px: 2 }}>
            <Card elevation={4} sx={{ borderRadius: 3 }}>
              <CardContent>
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 600,
                    mb: 2,
                    color: '#333',
                    marginLeft: '16px',
                    marginTop: '8px',
                  }}
                >
                  View All Reports
                </Typography>
                <Divider
                  style={{
                    marginLeft: '16px',
                    marginRight: '16px',
                    marginBottom: '8px',
                    height: '1px',
                    color: '#f4f4f4',
                  }}
                />

                <List>
                  {reports.map((report, index) => (
                    <ListItem
                      key={index}
                      button
                      onClick={() => this.fetchPdf(report.intent)}
                      sx={{
                        borderRadius: 2,
                        px: 2,
                        mb: 1,
                        transition: 'all 0.2s ease',
                        '&:hover': {
                          backgroundColor: '#e3f2fd',
                          transform: 'scale(1.01)',
                        },
                        display: 'flex',
                        alignItems: 'center',
                      }}
                    >
                      <ListItemText
                        primary={report.name}
                        primaryTypographyProps={{
                          fontSize: 16,
                          fontWeight: 500,
                          color: '#444',
                        }}
                        sx={{ flex: 1 }}
                      />

                      {/* Conditionally render Edit Icon */}
                      {report.intent === 'shift' && (
                        <IconButton
                          style={{ marginRight: '8px' }}
                          edge="end"
                          onClick={(e) => {
                            e.stopPropagation(); // Prevent ListItem onClick
                            this.setShiftReportView(true);
                          }}
                        >
                          <EditIcon sx={{ color: '#1976d2' }} />
                        </IconButton>
                      )}

                      {/* Always show Visibility Icon */}
                      <IconButton
                        edge="end"
                        onClick={(e) => {
                          e.stopPropagation();
                          this.fetchPdf(report.intent);
                        }}
                      >
                        <VisibilityIcon sx={{ color: '#1976d2' }} />
                      </IconButton>
                    </ListItem>
                  ))}
                </List>
              </CardContent>
            </Card>
          </Box>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  previewImage: previewBonusSelector(state),
  PDFPreviewReady: globalPDFPreviewReadySelector(state),
  reportPhotos: reportPhotosSelector(state),
  status: statusSelector(state),
});

const actionCreators = {
  clearStatus,
  getGlobalPDFPreview,
  resetGlobalPdfPreviewData,
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  ReportList
);
